// extracted by mini-css-extract-plugin
export var fileExt = "_sh-8";
export var fileIcon = "_sh-6";
export var fileLink = "_sh-5";
export var fileName = "_sh-7";
export var image = "_sh-1";
export var imageError = "_sh-3";
export var imageErrorIcon = "_sh-4";
export var imageLink = "_sh-0";
export var imageLoaded = "_sh-2";